import { useLocation, NavLink, Redirect } from "react-router-dom";

const REASON_MAP = {
    USER_CANCELLED: {
        title:     'Payment Cancelled',
        message:   'You cancelled the payment on the ICICI bank page.',
        icon:      'fa-times-circle',
        color:     '#f0ad4e',
        retryable: true,
        showTips:  false,
        showRefund: false,
    },
    PAYMENT_FAILED: {
        title:     'Payment Failed',
        message:   'Your payment could not be processed. Please check your card details and try again.',
        icon:      'fa-times-circle',
        color:     '#d9534f',
        retryable: true,
        showTips:  true,
        showRefund: false,
    },
    PAYMENT_ABORTED: {
        title:     'Payment Aborted',
        message:   'The transaction was aborted. Please try again.',
        icon:      'fa-times-circle',
        color:     '#d9534f',
        retryable: true,
        showTips:  true,
        showRefund: false,
    },
    VERIFICATION_FAILED: {
        title:     'Verification Failed',
        message:   'Payment verification failed. If an amount was deducted, it will be refunded within 5-7 business days.',
        icon:      'fa-exclamation-circle',
        color:     '#d9534f',
        retryable: false,
        showTips:  false,
        showRefund: true,
    },
    ORDER_NOT_FOUND: {
        title:     'Order Not Found',
        message:   'We could not find your order. Please contact support.',
        icon:      'fa-exclamation-circle',
        color:     '#d9534f',
        retryable: false,
        showTips:  false,
        showRefund: false,
    },
    PROCESSING_ERROR: {
        title:     'Processing Error',
        message:   'A server error occurred while processing your payment. Please contact support.',
        icon:      'fa-exclamation-circle',
        color:     '#d9534f',
        retryable: false,
        showTips:  false,
        showRefund: true,
    },
    UNKNOWN_STATUS: {
        title:     'Unknown Status',
        message:   'We could not determine your payment status. Please contact support.',
        icon:      'fa-question-circle',
        color:     '#f0ad4e',
        retryable: false,
        showTips:  false,
        showRefund: false,
    },
};

const PaymentFailure = () => {
    const location = useLocation();
    const query   = new URLSearchParams(location.search);
    const orderId = query.get("id");
    const reason  = query.get("reason");
    const code    = query.get("code");
    const message = query.get("message");

    if (!orderId) return <Redirect to="/login" />;

    const info = REASON_MAP[reason] || REASON_MAP.UNKNOWN_STATUS;

    return (
        <div className="container margin-t50">
            <div className="row">
                <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
                    <div className="panel panel-default">
                        <div className="panel-body text-center">
                            <i
                                className={`fa ${info.icon}`}
                                style={{ fontSize: '5rem', color: info.color, marginBottom: '1rem', display: 'block' }}
                            ></i>
                            <h2 style={{ color: info.color, marginTop: 0, marginBottom: '0.5rem' }}>{info.title}</h2>
                            <p className="text-muted">{message || info.message}</p>

                            {info.showRefund && (
                                <div className="alert alert-warning" style={{ textAlign: 'left', marginTop: '1rem' }}>
                                    <i className="fa fa-info-circle"></i>{' '}
                                    <strong>Refund Notice:</strong> If any amount was deducted from your account, it will be automatically refunded within 5-7 business days.
                                </div>
                            )}

                            {(orderId || code) && (
                                <div className="well well-sm" style={{ marginTop: '1rem', textAlign: 'left' }}>
                                    <table className="table table-condensed" style={{ marginBottom: 0 }}>
                                        <tbody>
                                            {orderId && (
                                                <tr>
                                                    <td><strong>Order ID</strong></td>
                                                    <td>{orderId}</td>
                                                </tr>
                                            )}
                                            {code && (
                                                <tr>
                                                    <td><strong>Error Code</strong></td>
                                                    <td><code>{code}</code></td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {info.showTips && (
                                <div className="well well-sm" style={{ marginTop: '1rem', textAlign: 'left' }}>
                                    <p style={{ marginBottom: '0.5rem' }}>
                                        <strong><i className="fa fa-lightbulb-o"></i> Tips for successful payment:</strong>
                                    </p>
                                    <ul style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
                                        <li>Ensure your card has sufficient balance</li>
                                        <li>Verify your card details are correct</li>
                                        <li>Check that online/international transactions are enabled</li>
                                        <li>Try a different payment method</li>
                                    </ul>
                                </div>
                            )}

                            <div style={{ marginTop: '1.5rem' }}>
                                {info.retryable && (
                                    <NavLink to="/my-booking" className="btn btn-warning btn-block" style={{ marginBottom: '0.5rem' }}>
                                        <i className="fa fa-refresh"></i> Try Again
                                    </NavLink>
                                )}
                                <NavLink to="/tee-booking" className="btn btn-default btn-block">
                                    <i className="fa fa-home"></i> Back to Home
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailure;
